var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-pieces-hint"},[_vm._v("\n  "+_vm._s(_vm.hint[0])+" "),_c('br'),_vm._v("\n  "+_vm._s(_vm.hint[1])+" "),_c('br'),_vm._v("\n  "+_vm._s(_vm.hint[2])+" "),_c('br'),_vm._v("\n  "+_vm._s(_vm.hint[3])+" "),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }